import React from 'react';

import { TYPE_ICONS } from '@/shared/Icons';

export function getTypeIcon(objectType: string, size = 48) {
  const IconComponent = TYPE_ICONS[objectType];
  return IconComponent ? <IconComponent size={size} /> : null;
}
